// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-info__icon[data-v-28cc3c90] {\n  color: #c9c9c9;\n  font-size: 50px;\n}\n.no-info__text[data-v-28cc3c90] {\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  color: #c9c9c9;\n}", ""]);
// Exports
module.exports = exports;
